import { Consent, ConsentWithId, Org } from '@/api';
import { ConsentsApi } from '@/api';

export type ConsentCouncil = {
	council?: Org;
};

export class ConsentModule {
	private api: ConsentsApi;
	constructor() {
		this.api = new ConsentsApi();
	}

	public async getConsentsForProduct(
		productId: number,
	): Promise<(ConsentWithId & ConsentCouncil)[]> {
		const res = await this.api.getConsents({
			params: {
				'filter[productId]': productId,
				include: 'council,consentConditions,consentConditions.consentConditionType',
			},
		});
		if (res != undefined && res.data != undefined && res.data.data != undefined) {
			return res.data.data;
		}
		return [];
	}

	public validate(): Boolean {
		return true;
	}

	public async getRegionalCouncils() {}

	/*
	 *
	 * @throws error
	 */
	public async save(consent: Consent): Promise<boolean> {
		try {
			if (consent.id !== undefined) {
				await this.api.patchConsent(consent.id, { data: consent });
			} else {
				await this.api.postConsent({ data: consent });
			}
			return true;
		} catch (err) {
			return false;
		}
	}
}
